var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.235 12h-.47l.117-1.73c-.006-.09-.054-.115-.235-.108l-1.882.216s.353-.432.353-.648C9.118 9.514 7 8.108 7 8.108s.47-.108.588-.216-.47-1.297-.47-1.297 1.195.432 1.294.324c.098-.108.235-.54.235-.54s.941.972 1.177.972c.235 0-.471-2.378-.471-2.378s.588.432.824.432C10.412 5.405 11 4 11 4s.588 1.405.706 1.405c.117 0 .941-.432.941-.432s-.588 2.27-.47 2.378c.117.108 1.176-.973 1.176-.973s.118.433.235.54c.118.109 1.294-.323 1.294-.323s-.588 1.189-.47 1.297c.117.108.588.216.588.216s-2.118 1.406-2.118 1.622c0 .216.236.648.236.648l-1.765-.216c-.142-.037-.191-.009-.235.108l.117 1.73ZM17 0h5v16h-5zM0 0h5v16H0z",
    fill: "#F93939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/ca.e0eb1e6de425d1e37014ae6cd458f59b.svg";
export { ForwardRef as ReactComponent };